import { fetchAuthSession } from 'aws-amplify/auth';
import { AuthUser, Credentials } from '@/types/auth.types';

export interface UseAuthReturn {
  user: AuthUser | null;
  isAuthenticated: boolean;
  isLoading: boolean;
  signOut: () => void;
  getCredentials: () => Promise<Credentials>;
}

export function useAuth(): UseAuthReturn {
  const getCredentials = async (): Promise<Credentials> => {
    try {
      const session = await fetchAuthSession();
      
      if (!session.credentials) {
        throw new Error('No credentials available');
      }

      return {
        accessKeyId: session.credentials.accessKeyId,
        secretAccessKey: session.credentials.secretAccessKey,
        sessionToken: session.credentials.sessionToken || '',
        expiration: session.credentials.expiration,
      };
    } catch (error) {
      console.error('Failed to get credentials:', error);
      throw error;
    }
  };

  return {
    user: null,        // No user for anonymous access
    isAuthenticated: true,  // Always true for anonymous
    isLoading: false,
    signOut: () => {},
    getCredentials,
  };
}
